"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_HAUT_RESULTS_OPTIONS = exports.HAUT_QUALITY_ALGORITHM_ERRORS = exports.HAUT_FIXED_WARNING_MESSAGE = exports.HAUT_FIXED_WARNINGS = exports.HAUT_FIXED_ERROR_MESSAGE_HAIR = exports.HAUT_FIXED_ERROR_MESSAGE_SKIN = exports.HAUT_FIXED_ERRORS = exports.HAUT_QUALITY_ALGORITHM_MAX_ERRORS = exports.HAUT_QUALITY_ALGORITHM_VERSION_ID = exports.IMAGE_TYPE = exports.APP_NAME = exports.HAUT_SKIN_ERRORS = exports.HAUT_HAIR_ERRORS = void 0;
const HAUT_HAIR_ERRORS = {
    "Eyes Bags score can't be calculated": 'HautBadImageError',
    'division by zero': 'HautBadImageError',
    'float division by zero': 'HautBadImageError',
    'No face detected': 'HautNoFaceError',
    'Oops, something went wrong, please try analysing the image again!': 'HautBadImageError',
    'Face is rotated': 'HautFaceRotatedError',
};
exports.HAUT_HAIR_ERRORS = HAUT_HAIR_ERRORS;
const HAUT_SKIN_ERRORS = {
    "Eyes Bags score can't be calculated": 'HautBadImageError',
    'division by zero': 'HautBadImageError',
    'float division by zero': 'HautBadImageError',
    'No face detected': 'HautNoFaceError',
    'Oops, something went wrong, please try analysing the image again!': 'HautBadImageError',
    'Face is rotated': 'HautFaceRotatedError',
};
exports.HAUT_SKIN_ERRORS = HAUT_SKIN_ERRORS;
const APP_NAME = {
    HAIR: 'HAIR',
    SKIN: 'SKIN',
};
exports.APP_NAME = APP_NAME;
const IMAGE_TYPE = {
    HAIR_SLEFIE: 'hair_selfie',
};
exports.IMAGE_TYPE = IMAGE_TYPE;
// Quality Algo Related Errors
exports.HAUT_QUALITY_ALGORITHM_VERSION_ID = 43;
exports.HAUT_QUALITY_ALGORITHM_MAX_ERRORS = 4;
exports.HAUT_FIXED_ERRORS = ['no_detection', 'out_of_frame'];
exports.HAUT_FIXED_ERROR_MESSAGE_SKIN = 'Your analysis failed because the image quality was too low for accurate processing.';
exports.HAUT_FIXED_ERROR_MESSAGE_HAIR = "Your analysis failed because the hair was not fully visible, or it couldn't be detected";
exports.HAUT_FIXED_WARNINGS = ['low_resolution', 'misfocus_or_distortion', 'too_dark', 'too_bright', 'colored_illumination', 'strong_shadows'];
exports.HAUT_FIXED_WARNING_MESSAGE = 'Your analysis results are not accurate because the image quality is very bad. Please use a better quality image to get the most accurate analysis.';
exports.HAUT_QUALITY_ALGORITHM_ERRORS = {
    no_detection: 'No face detected',
    out_of_frame: 'Face is not fully visible',
    far_from_camera: 'Face is too far from camera',
    wrong_angle: 'Head is rotated at the wrong angle',
    skin_occlusion: 'Skin is partially not visible',
    low_resolution: 'Low face resolution',
    misfocus_or_distortion: 'Image is distorted or blurred',
    compression_artifacts: 'Image compression artifacts are visible',
    noise: 'Noisy image',
    too_dark: 'Image is too dark',
    too_bright: 'Image is too bright',
    strong_shadows: 'Front facing light required',
    colored_illumination: 'Incorrect white balance',
};
exports.DEFAULT_HAUT_RESULTS_OPTIONS = {
    interval: 6000,
    enableFailAnalysisOnQualityAlgo: false,
};
